import { render } from "./SortableList.vue?vue&type=template&id=2a682c0f&scoped=true"
import script from "./SortableList.vue?vue&type=script&lang=js"
export * from "./SortableList.vue?vue&type=script&lang=js"

import "./SortableList.vue?vue&type=style&index=0&id=2a682c0f&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a682c0f"]])

export default __exports__